<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="equipments"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editEquipment.open(0)">新建</el-button>
        <!--        <el-button type="danger" @click="deleteIds">批量删除</el-button>-->
        <el-button type="primary" @click="qrCodes">批量打印</el-button>
        <el-upload
            :action="uploadUrl"
            :before-upload="beforeAvatarUpload"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin-right: 5px;margin-left: 20px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="primary">导入</el-button>
        </el-upload>
        <el-button icon="el-icon-download" type="primary" @click="downloadExcel()">下载导入模板</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="名称">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="型号">
            <el-input v-model.trim="filter.model" clearable/>
          </vm-search>
          <vm-search label="关键设备">
            <el-select v-model.trim="filter.keyEquipment" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.keyEquipment)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="no" align="center" label="设备编号"/>
      <el-table-column prop="propertyNo" align="center" label="资产编号"/>
      <el-table-column prop="name" align="center" label="名称"/>
      <el-table-column prop="model" align="center" label="型号"/>
      <el-table-column prop="location" align="center" label="位置"/>
      <el-table-column prop="dealer" align="center" label="销售方"/>
      <el-table-column prop="purchaseDate" align="center" label="购入日期"/>
      <el-table-column prop="maintenanceCycle" align="center" label="维护周期"/>
      <el-table-column
          v-if="editAuth"
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="200px">
        <template slot-scope="scope">
          <el-button type="info" @click="$refs.editEquipment.open(scope.row.pkid)">编辑</el-button>
          <el-button type="primary" @click="$refs.qrCode.open(scope.row)">生成二维码</el-button>
          <el-button type="primary" @click="$refs.history.open(scope.row.pkid)">历史工单</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <equipment-edit ref="editEquipment" @save-success="getList(1)"/>
    <q-r-code ref="qrCode"/>
    <equipment-history-order ref="history"/>
    <q-r-codes ref="qrCodes"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EquipmentEdit from "@/views/em/Equipment/EquipmentEdit";
  import QRCode from "@/views/em/Equipment/QRCode";
  import EquipmentHistoryOrder from "@/views/em/Equipment/EquipmentHistoryOrder";
  import QRCodes from "@/views/em/Equipment/QRCodes";
  import constant from "../../../util/constant";

  export default {
    name: "EquipmentList",
    components: {QRCodes, EquipmentHistoryOrder, QRCode, EquipmentEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        constant,
        editAuth: this.$auth(91),
        exportLoading: false,
        importLoading: false,
        uploadUrl: window.config.basicServerHttpUrl + "equipments/importExcel",
        disabled: false,
        filter: {
          no: "",
          name: "",
          model: "",
          keyEquipment: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      qrCodes() {
        if(this.idList.length) {
          console.log(this.idList.length);
          this.$refs.qrCodes.open(this.idList);
        }else{
          this.$message.error("请选择要打印二维码设备");
        }
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          console.log(ids);
          this.$http
            .delete("basic","equipments/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
      downloadExcel() {
        window.open("/publicFile/设备导入模板.xlsx");
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","equipments",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
